/**
 * main.tsx — Surface Layer (/01)
 *
 * Entry point. Loads global SCSS (Carbon + UI Shell + surface partials)
 * and mounts <App /> into #root.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './carbon-products-runtime';
import { App } from './App';
import './styles/globals.scss';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Surface Layer mount target #root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>
);
